module.exports = __webpack_public_path__ + "static/media/Commercial-9.28ced06b.jpg";